module.exports = __webpack_public_path__ + "static/media/icon14.40a99950.png";